
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guestportal",
      function () {
        return require("private-next-pages/guestportal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guestportal"])
      });
    }
  